"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCalendarsBaseUrl = exports.setBaseUrl = exports.audits = exports.featureFlags = exports.locations = exports.calendars = exports.carrierAccounts = void 0;
const calendarsV0 = require("./calendars.v0");
exports.calendars = calendarsV0;
const carrierAccountsV0 = require("./carrier-accounts.v0");
exports.carrierAccounts = carrierAccountsV0;
const featureFlagsV0 = require("./feature-flags.v0");
exports.featureFlags = featureFlagsV0;
const locationsV0 = require("./locations.v0");
exports.locations = locationsV0;
const auditsV0 = require("./audits.v0");
exports.audits = auditsV0;
const shared_1 = require("./shared");
Object.defineProperty(exports, "setBaseUrl", { enumerable: true, get: function () { return shared_1.setBaseUrl; } });
Object.defineProperty(exports, "setCalendarsBaseUrl", { enumerable: true, get: function () { return shared_1.setCalendarsBaseUrl; } });
//# sourceMappingURL=index.js.map